module.exports = __webpack_public_path__ + "static/media/snapcount.d1817c70.webp";